import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function LegalPage() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("condizioni");

  useEffect(() => {
    if (location.pathname.includes("recesso")) setActiveTab("recesso");
    else if (location.pathname.includes("privacy")) setActiveTab("privacy");
    else if (location.pathname.includes("cookie")) setActiveTab("cookie");
    else setActiveTab("condizioni");
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="bg-white min-h-screen py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        {/* Header */}
        <div className="border-b border-black pb-8 mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--bs-red)] mb-2">
            Documentazione Legale & Trasparenza
          </div>
          <h1 className="font-display font-black text-3xl sm:text-5xl tracking-tight">
            Note Legali & Informazioni sul servizio
          </h1>
          <p className="text-sm text-zinc-500 mt-2 font-mono-bs">
            ALBA JON S.R.L.S. — P.IVA 02390170500 — Via Spagna 19, 56032 Buti (PI)
          </p>
        </div>

        {/* Tab Buttons */}
        <div className="flex flex-wrap gap-2 mb-10 border-b border-zinc-200 pb-4">
          <button
            type="button"
            onClick={() => setActiveTab("condizioni")}
            className={`px-4 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors ${
              activeTab === "condizioni"
                ? "bg-black text-white"
                : "bg-zinc-100 text-zinc-700 hover:bg-zinc-200"
            }`}
          >
            Informazioni generali
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("recesso")}
            className={`px-4 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors ${
              activeTab === "recesso"
                ? "bg-black text-white"
                : "bg-zinc-100 text-zinc-700 hover:bg-zinc-200"
            }`}
          >
            Ritiro e disponibilità
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("privacy")}
            className={`px-4 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors ${
              activeTab === "privacy"
                ? "bg-black text-white"
                : "bg-zinc-100 text-zinc-700 hover:bg-zinc-200"
            }`}
          >
            Privacy Policy (GDPR)
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("cookie")}
            className={`px-4 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors ${
              activeTab === "cookie"
                ? "bg-black text-white"
                : "bg-zinc-100 text-zinc-700 hover:bg-zinc-200"
            }`}
          >
            Cookie Policy
          </button>
        </div>

        {/* Contenuto */}
        <div className="text-zinc-800 text-sm leading-relaxed space-y-6">
          {activeTab === "condizioni" && (
            <div className="space-y-6">
              <h2 className="text-xl font-bold font-display uppercase tracking-tight text-black">
                1. Informazioni Generali
              </h2>
              <p>
                Il presente sito-vetrina Buti Stock è gestito da <strong>ALBA JON S.R.L.S.</strong>, con sede legale in Via Spagna 19, 56032 Buti (PI), P.IVA e C.F. 02390170500.
              </p>
              
              <h3 className="text-base font-bold text-black">1.1 Natura dei Beni in Vendita</h3>
              <p>
                Buti Stock è specializzata nella commercializzazione di articoli provenienti da <strong>stock aziendali, fine serie, chiusure attività, fallimenti commerciali e beni usati/revisionati</strong>. I prodotti possono essere nuovi con imballo originale sigillato, nuovi con imballo aperto o ex esposizione. Lo stato specifico di ciascun articolo è indicato nella rispettiva scheda prodotto.
              </p>

              <h3 className="text-base font-bold text-black">1.2 Prezzi e Modalità di Pagamento</h3>
              <p>
                I prezzi esposti sul sito hanno funzione informativa. Il sito consente di inviare una richiesta di prenotazione tramite WhatsApp per il successivo ritiro in sede; la richiesta non costituisce conferma della disponibilità.
              </p>

              <h3 className="text-base font-bold text-black">1.3 Disponibilità e Pezzi Unici</h3>
              <p>
                Trattandosi di stock, fine serie e pezzi in quantità limitata, la disponibilità mostrata sul sito è indicativa. La prenotazione è valida solo dopo conferma esplicita dello staff tramite WhatsApp.
              </p>
            </div>
          )}

          {activeTab === "recesso" && (
            <div className="space-y-6">
              <h2 className="text-xl font-bold font-display uppercase tracking-tight text-black">2. Disponibilità e ritiro in sede</h2>
              <p>I prodotti possono essere richiesti tramite WhatsApp e ritirati presso la sede indicata dal personale dopo conferma.</p>
              <div className="bg-zinc-100 border-l-4 border-black p-4 text-xs font-mono-bs"><strong>IMPORTANTE:</strong> l’invio della richiesta dal sito non garantisce la disponibilità e non costituisce conferma della prenotazione. Attendere sempre il messaggio di conferma prima di recarsi in sede.</div>
              <p>Per informazioni sulle caratteristiche, sullo stato dei beni, sulle condizioni applicabili alla vendita in sede e sulle tutele previste dalla normativa vigente, contattare lo staff prima del ritiro.</p>
            </div>
          )}

          {activeTab === "privacy" && (
            <div className="space-y-6">
              <h2 className="text-xl font-bold font-display uppercase tracking-tight text-black">
                3. Trattamento dei Dati Personali (GDPR)
              </h2>
              <p>
                Informativa resa ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR).
              </p>
              <h3 className="text-base font-bold text-black">3.1 Titolare del Trattamento</h3>
              <p>
                Il Titolare del trattamento è <strong>ALBA JON S.R.L.S.</strong>, Via Spagna 19, 56032 Buti (PI), P.IVA 02390170500, email: <code>info@butistock.it</code>.
              </p>
              <h3 className="text-base font-bold text-black">3.2 Finalità</h3>
              <p>
                I dati eventualmente forniti dall’utente vengono utilizzati per gestire le richieste di disponibilità, prenotazione, contatto e ritiro dei prodotti.
              </p>
            </div>
          )}

          {activeTab === "cookie" && (
            <div className="space-y-6">
              <h2 className="text-xl font-bold font-display uppercase tracking-tight text-black">
                4. Informativa Cookie
              </h2>
              <p>
                Il sito Buti Stock può utilizzare cookie o tecnologie tecniche necessarie al funzionamento del catalogo, della lista di richiesta e dell’area amministrativa.
              </p>
            </div>
          )}
        </div>

        {/* Box Contatto */}
        <div className="mt-12 p-6 bg-zinc-50 border border-zinc-200 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div>
            <div className="font-bold text-sm">Hai bisogno di informazioni o assistenza?</div>
            <div className="text-xs text-zinc-500">Il nostro staff è a disposizione per ogni richiesta.</div>
          </div>
          <a
            href="mailto:info@butistock.it"
            className="bs-btn-primary px-6 py-3 text-xs font-bold uppercase tracking-widest inline-block text-center"
          >
            Contattaci via Email
          </a>
        </div>
      </div>
    </div>
  );
}